export default {
  meta: {
    title: '广告位管理'
  }
};
